import './CoverPage.css';
import {
  Title,
  Stack,
  DescriptionList
} from '@efast_public/fjd-component-library';
import React from 'react';
import _moment from 'moment';
import { useTranslation } from 'react-i18next';
import { CaseDetailsModel } from '../../api/models/Case/CaseDetailsModel';

interface CoverPageProps {
  caseDetails: CaseDetailsModel;
}

export function CoverPage({ caseDetails }: CoverPageProps) {
  const { t } = useTranslation();

  return (
    <Stack spacing="5xl" className="cover-page__container">
      <div className="cover-page__heading">
        <Title level={1}>{caseDetails?.name}</Title>
      </div>
      <div className="cover-page__subheading">
        <DescriptionList>
          <DescriptionList.Item
            key={'vorgangsnummer'}
            title={t('antragPrint.coverPage.vorgangsnummer')}
            description={
              <span className="prevent-line-break">{caseDetails?.caseId}</span>
            }
          />
          <DescriptionList.Item
            key={'versand'}
            title={t('antragPrint.coverPage.eingang')}
            description={
              caseDetails?.createdOn ? (
                <span className="prevent-line-break">
                  {_moment
                    .utc(caseDetails.createdOn)
                    .local()
                    .format('DD.MM.YYYY, HH:mm')}
                </span>
              ) : (
                '-'
              )
            }
          />
        </DescriptionList>
      </div>
      <div>
        <div style={{ display: 'flex', paddingBottom: '8px' }}>
          <h2>{t('antragPrint.coverPage.metadaten')}</h2>
          <hr className="cover-page__headline_border" />
        </div>
        <DescriptionList>
          <DescriptionList.Item
            key={'empfaenger'}
            title={t('antragPrint.coverPage.empfaenger')}
            description={caseDetails?.organizationalUnitName}
          />
          <DescriptionList.Item
            key={'eBescheid'}
            title={t('antragPrint.coverPage.eBescheid')}
            description={
              caseDetails?.isEBescheidConsentGiven
                ? t('antragPrint.coverPage.eBescheid.eingewilligt')
                : t('antragPrint.coverPage.eBescheid.abgelehnt')
            }
          />
          <DescriptionList.Item
            key={'eidasLevel'}
            title={t('antragPrint.coverPage.vertrauensniveau')}
            description={
              caseDetails?.eidasLevel
                ? t(`eidasLevel.${caseDetails.eidasLevel.toLowerCase()}`)
                : t('antragPrint.coverPage.vertrauensniveau.unbekannt')
            }
          />
          {caseDetails.isBeschieden ? (
            <DescriptionList.Item
              key={'versandweg'}
              title={t('antragPrint.coverPage.versandweg')}
              description={
                caseDetails?.isPostalisch
                  ? t('antragPrint.coverPage.versandweg.postalisch')
                  : t('antragPrint.coverPage.versandweg.digital')
              }
            />
          ) : (
            <></>
          )}
        </DescriptionList>
      </div>
    </Stack>
  );
}
